import React from "react";
import Link from 'next/link';
import LinksProvider from '../../../services/http/LinksProvider';
import css from './LoginButton.module.scss';

const LoginButton = () => {
  const loginUrl = LinksProvider.getFullRoute(LinksProvider.ROUTES.AUTH.SIGN_IN);

  return (
    <Link href={loginUrl} passHref>
      <button className={css.auth__btn}>
        <img src="/static/images/pictos/icon-user.svg" alt="User Icon" />
        <span className={css.auth__content}>Connexion</span>
      </button>
    </Link>
  );
};

export default LoginButton;
